module.exports = __webpack_public_path__ + "img/21.8c6ae867.jpg";